const message = `
 _   _ _                               ____        _   _   _ _             
| \\ | (_)                             |  _ \\      | | | | | (_)            
|  \\| |_  __ _  __ _  __ _ _ __ __ _  | |_) | ___ | |_| |_| |_ _ __   __ _ 
| . \` | |/ _\` |/ _\` |/ _\` | '__/ _\` | |  _ < / _ \\| __| __| | | '_ \\ / _\` |
| |\\  | | (_| | (_| | (_| | | | (_| | | |_) | (_) | |_| |_| | | | | | (_| |
|_| \\_|_|\\__,_|\\__, |\\__,_|_|  \\__,_| |____/ \\___/ \\__|\\__|_|_|_| |_|\\__, |
 _____          __/ |_______                                          __/ |
|  __ \\        |___/|__   __|                                        |___/ 
| |  | | _____   __    | | ___  __ _ _ __ ___                              
| |  | |/ _ \\ \\ / /    | |/ _ \\/ _\` | '_ \` _ \\                             
| |__| |  __/\\ V /     | |  __/ (_| | | | | | |                            
|_____/ \\___| \\_/      |_|\\___|\\__,_|_| |_| |_|      

               ___
            .="   "=._.---.
          ."         c ' Y'\`ↄ
         /    ,      \`.  w_/
         |    '-.   /    /
   _,..._|       )_-\\ \\_=.\\
  \`-....-'\`----)))\`=-'"\`'"

`;

console.log(`%c ${message}`, 'color: #2FD2FE;')